export default __webpack_public_path__ + "static/media/HEC.3c617154.svg";